import React from 'react'

export default function VirtualCongressBackground({backgroundImage, children, id, ...props}) {
  return <div className="row no-gutters virtual-congress-background image-map-row" id={id} style={{
      // position: "absolute",
      left: 0, right: 0, top: 0
    }} {...props}>
      <div className="col">
        {backgroundImage && 
          <div className="virtual-congress-background-image-div" style={{position: "absolute"}}>
            <img src={backgroundImage} style={{width: "100%"}}/>
          </div>
        }
        <div style={{position: "relative"}}>
          {children}
        </div>
      </div>
    </div>
}